import {
  QUOTE_LINE_INFO_TABS,
  QUOTE_PRICE_FIELDS,
  QUOTE_PRICE_STRATEGY_BADGE_COLORS,
} from '../constants';
import { PriceStrategyUIConfigEntry } from '../types';

export const fixedMarketUIConfig: PriceStrategyUIConfigEntry = {
  badge: {
    color: QUOTE_PRICE_STRATEGY_BADGE_COLORS.FIXED,
    label: 'Market',
  },
  partDetailsExtraComponents: [],
  fields: [
    {
      field: QUOTE_PRICE_FIELDS.quantity,
      editable: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.unitCost,
      editable: false,
      isCostFieldForFixedPriceStrategy: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.unitPrice,
      editable: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.grossMargin,
      editable: false,
      isCostFieldForFixedPriceStrategy: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.contributionMargin,
      editable: false,
      isCostFieldForFixedPriceStrategy: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.leadTimeWeeks,
      editable: true,
    },
  ],
  tabs: [
    QUOTE_LINE_INFO_TABS.QUOTE_HISTORY,
    QUOTE_LINE_INFO_TABS.MARKET_PRICE_BOOK,
    QUOTE_LINE_INFO_TABS.ORDER_HISTORY,
    QUOTE_LINE_INFO_TABS.COST_OVERVIEW,
    QUOTE_LINE_INFO_TABS.COST_BREAKS,
  ],
} as const;
